import { IconX } from "@tabler/icons-react";
import type { ReaderCustomField } from "../../types";
import { ReaderMetaInfo } from "../reader-meta-info";

export type TReaderInfo = {
  name: string | null;
  email: string | null;
  position: string | null;
  customFields?: ReaderCustomField[] | null;
};

type TSessionDetailsHeaderProps = {
  readerNumber?: number;
  sessionNumber?: number;
  readerInfo?: TReaderInfo;
  storyName?: string;
  versionName?: string;
  onClose?: () => void;
  singleSessionVisitor?: boolean;
};

export const SessionDetailsHeader = ({
  readerNumber,
  sessionNumber,
  readerInfo,
  storyName,
  versionName,
  singleSessionVisitor,
  onClose,
}: TSessionDetailsHeaderProps) => {
  const displayName = readerInfo?.name || `Reader #${readerNumber}`;

  return (
    <div className="tw-py-4 tw-grid tw-grid-cols-[minmax(0,1fr)_200px_200px] tw-items-start tw-gap-4 tw-relative -lg:tw-grid-cols-2 -lg:tw-p-0">
      <div className="tw-flex tw-flex-col tw-gap-2 tw-min-w-0 -lg:tw-gap-1 -lg:tw-col-span-2 -lg:tw-mb-2">
        <span className="tw-text-blue-500 tw-text-lg tw-font-normal tw-font-sans tw-block -lg:tw-text-sm">
          Session details
        </span>
        <div className="tw-flex tw-items-center tw-gap-4 tw-flex-wrap -lg:tw-flex-col -lg:tw-items-start -lg:tw-gap-4">
          <h2 className="tw-text-2xl tw-font-semibold tw-font-sans tw-text-blue -lg:tw-text-xl tw-truncate t-max-w-full tw-min-w-0">
            {displayName}
          </h2>
          <div className="tw-flex tw-items-center tw-gap-4 -lg:tw-gap-2 tw-min-w-0 tw-max-w-full tw-overflow-hidden">
            {!singleSessionVisitor && (
              <span className="tw-px-1.5 tw-py-0.5 tw-text-nowrap tw-text-blue-500 tw-rounded-full tw-bg-blue-100 tw-text-xs tw-font-normal tw-font-sans">
                Session #{sessionNumber}
              </span>
            )}
            <ReaderMetaInfo
              position={readerInfo?.position}
              email={readerInfo?.email}
              customFields={readerInfo?.customFields}
            />
          </div>
        </div>
      </div>
      <div className="-lg:tw-py-2">
        <p className="tw-mt-0 tw-mb-1.5 tw-font-sans tw-text-sm tw-font-semibold tw-text-blue">
          Story
        </p>
        <p className="tw-my-0 tw-font-sans tw-text-sm tw-truncate tw-font-normal tw-text-blue">
          {storyName || "Not available"}
        </p>
      </div>
      <div className="-lg:tw-py-2">
        <p className="tw-mt-0 tw-mb-1.5 tw-font-sans tw-truncate tw-text-sm tw-font-semibold tw-text-blue">
          Version
        </p>
        <p className="tw-my-0 tw-font-sans tw-text-sm tw-truncate tw-font-normal tw-text-blue">
          {versionName || "Not available"}
        </p>
      </div>
      <button
        type="button"
        className="tw-flex tw-cursor-pointer tw-items-center tw-group/close tw-justify-center tw-absolute tw-top-1.5 tw-right-0"
        onClick={onClose}
      >
        <IconX className="tw-size-4 tw-text-blue-500 group-hover/close:tw-text-blue tw-transition-colors" />
      </button>
    </div>
  );
};
